import React, { Fragment } from 'react'
import { Segment, Header, Grid, Label, List } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { konstants } from '@vizeat/helpers'

export function LocationAndVenueSection({ hostApplication }) {
  const { t } = useTranslation()

  return (
    <Segment>
      <Header as='h3'>{t('HostApplications::Summary::Location & Venue')}</Header>
      <Segment basic>
        <Grid columns={1}>
          <Grid.Column>
            {hostApplication.getIn(['sample_experience', 'description', 'neighbourhood']) && (
              <Fragment>
                <Header size='small'>{t('HostApplications::Summary::Additional place details')}</Header>
                {hostApplication.getIn(['sample_experience', 'description', 'neighbourhood'])}
              </Fragment>
            )}
            {(hostApplication.getIn(['sample_experience', 'place', 'place_type']) ||
              hostApplication.getIn(['sample_experience', 'place', 'event_space'])) && (
              <Fragment>
                <Header size='small'>{t('HostApplications::Summary::Type of venue')}</Header>
                <Label basic circular>
                  {hostApplication.getIn(['sample_experience', 'place', 'place_type']) ||
                    hostApplication.getIn(['sample_experience', 'place', 'event_space'])}
                </Label>
              </Fragment>
            )}
            {hostApplication.getIn(['sample_experience', 'place', 'WOW_factor']).size > 0 && (
              <Fragment>
                <Header size='small'>{t('HostApplications::Summary::WOW factors')}</Header>
                <List horizontal>
                  {hostApplication.getIn(['sample_experience', 'place', 'WOW_factor']).map((wowFactor) => (
                    <List.Item key={wowFactor}>
                      <Label basic circular>
                        {wowFactor}
                      </Label>
                    </List.Item>
                  ))}
                </List>
              </Fragment>
            )}
            {hostApplication.getIn(['metadata', 'status']) === konstants.HOST_APPLICATION_STATUSES.UNSUPPORTED_AREA && (
              <Fragment>
                <Header size='small'>{t('HostApplications::StatusOptions::Unsupported area')}</Header>
                <Label basic>{hostApplication.getIn(['place', 'address'])}</Label>
              </Fragment>
            )}
          </Grid.Column>
        </Grid>
      </Segment>
    </Segment>
  )
}

LocationAndVenueSection.propTypes = {
  hostApplication: PropTypes.object.isRequired,
}
